module.exports = __webpack_public_path__ + "static/img/Inspection32.3efac614.png";